import { Quote } from "lucide-react";
import { Counter } from "@/components/fx/Counter";
import { Reveal, SplitLines } from "@/components/fx/Reveal";
import { SectionCta } from "@/components/SectionCta";

const CASES = [
  {
    tag: "Caso 1", sector: "Centro estetico",
    brief: "2 receptionist capaci di vendere + 2 estetiste con competenze avanzate.",
    details: ["Profili difficili, non si trovano con un annuncio su un portale.", "Nessun colloquio organizzato dall'azienda."],
    stats: [
      { to: 60, label: "giorni" },
      { to: 160, label: "candidature qualificate" },
      { to: 4, suffix: "/4", label: "posizioni coperte", match: true },
    ],
    note: "Il titolare non ha letto un CV.",
  },
  {
    tag: "Caso 2", sector: "Azienda B2B",
    brief: "Commerciali plurimandatari con portafoglio clienti in tutta Italia.",
    details: ["Almeno uno per regione in prima battuta.", "Profili rari. Mercato competitivo."],
    stats: [
      { to: 50, label: "giorni" },
      { to: 60, label: "candidature qualificate" },
      { to: 3, suffix: "+", label: "assunzioni confermate", match: true },
    ],
    note: "Altre in valutazione.",
  },
];

const CaseCard = ({ c, idx }) => (
  <article className="rl-card relative overflow-hidden p-7 sm:p-10 lg:p-12" data-testid={`case-card-${idx + 1}`}>
    <div className="flex flex-wrap items-center justify-between gap-3">
      <span className="font-mono-data text-[12px] uppercase tracking-[0.16em] text-[#0F6E56]">{c.tag}</span>
      <span className="rounded-full border border-[#E7E5DF] px-3 py-1 text-[13px] text-[#6B6961]">{c.sector}</span>
    </div>
    <h3 className="mt-8 max-w-[520px] text-2xl leading-snug tracking-[-0.02em] sm:text-[28px]">{c.brief}</h3>
    <ul className="mt-6 space-y-2" data-testid={`case-${idx + 1}-details`}>
      {(c.details || []).map((d) => (
        <li key={d} className="flex items-start gap-3 text-[15px] text-[#2C2C2A]/80">
          <span className="mt-[9px] h-1.5 w-1.5 shrink-0 rounded-full bg-[#0F6E56]" />
          {d}
        </li>
      ))}
    </ul>
    <dl className="mt-12 grid grid-cols-1 gap-8 border-t border-[#E7E5DF] pt-10 sm:grid-cols-3 sm:gap-6">
      {c.stats.map((s, i) => (
        <div key={s.label}>
          <dt className="sr-only">{s.label}</dt>
          <dd>
            <Counter
              to={s.to}
              suffix={s.suffix || ""}
              testId={`case-${idx + 1}-counter-${i}`}
              className={`block text-[clamp(3rem,6vw,5rem)] font-medium leading-none tracking-[-0.04em] ${s.match ? "text-[#EF9F27]" : "text-[#0F6E56]"}`}
            />
            <span className="mt-3 block text-[14px] leading-snug text-[#2C2C2A]/80">{s.label}</span>
          </dd>
        </div>
      ))}
    </dl>
    <p className="mt-10 inline-flex items-center gap-3 rounded-full bg-[#F7F6F2] px-5 py-3 text-[15px] font-medium">
      <Quote size={16} className="text-[#0F6E56]" /> {c.note}
    </p>
  </article>
);

export const Risultati = ({ eyebrow = "Risultati", lines = ["Risultati reali,", "numeri reali."], cases = CASES, cta = null }) => (
  <section id="risultati" className="rl-section relative border-t border-[#E7E5DF] bg-white py-28 lg:py-40" data-testid="risultati-section">
    <div className="rl-container">
      <p className="rl-eyebrow text-[#0F6E56]">{eyebrow}</p>
      <SplitLines className="rl-h2 mt-6" lines={lines} data-testid="risultati-title" />
      <div className="mt-16 grid gap-6 lg:mt-24 lg:grid-cols-2">
        {cases.map((c, i) => (
          <Reveal key={c.tag} delay={i * 140} className="rl-fade">
            <CaseCard c={c} idx={i} />
          </Reveal>
        ))}
      </div>
      {cta && <SectionCta label={cta} testId="risultati-cta" />}
    </div>
  </section>
);
